<div
  *ngrxLet="isSelected$ as isSelected"
  class="h-12 flex items-center cursor-pointer p-2"
  [ngClass]="{ 'bg-blue': isSelected, 'hover:bg-cyan': !isSelected }"
  (click)="filterClick(isSelected)"
>
  <span class="w-48" [ngClass]="{ 'text-white': isSelected }">
    {{ hasTranslation ? (filter.translationKey | transloco) : filter.translationKey }}
  </span>
  <span class="ml-auto" [ngClass]="[isSelected ? 'text-white' : 'text-gray-dark']">{{ filter.count }}</span>
</div>
